import { OBJECT } from '@pkg/config/sanity/schemas';
import { PageReferenceTypes, type PageReference } from '@pkg/sanity-utils/linkQueries';
import type { LinkType } from '../types';

export const isPageReference = (link: LinkType): link is PageReference => {
  return PageReferenceTypes.includes(link._type as any);
};

export const getLinkKey = (link: LinkType) => {
  if (link._type === OBJECT.NAVIGATION_LINK_INTERNAL) {
    return link._key ?? link.reference?.slug;
  }

  if (isPageReference(link)) {
    return link._key ?? link.slug;
  }

  return link._key ?? link.url;
};
